import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { RoundExpandableButton } from '../../../../components/RoundExpandableButton/RoundExpandableButton';
import * as actions from '../../../../../redux/testMode/actions.testMode';
import TextareaAutosize from 'react-textarea-autosize';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import cancelEvent from '../../../../../services/mini/cancelEvent';
import getConversationId from '../../../../../services/mini/getConversationId';
class RequestEditor extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            text: props.text || '',
        };
    }

    onChange = (e) => {
        this.setState({ text: e.target.value });
    }

    onBlur = () => {
        const { text } = this.state;
        if (text !== this.props.text) {
            this.update();
        } else {
            this.exitEditMode();
        }
    }

    onKeyDown = (e) => {
        let keyCode = e.keyCode || e.which;

        if (keyCode === 13) {
            cancelEvent(e);
            this.update();
            return;
        } else if (keyCode === 27) {
            this.exitEditMode();
        }
    }

    exitEditMode = () => {
        this.props.onExitEditMode();
    }

    update = () => {
        const { text } = this.state;
        const { onUpdate, isModelActual } = this.props;
        if (!isModelActual) return;
        if (text.trim().length > 0) {
            onUpdate({ text });
        }
    }

    render() {
        const { text } = this.state;
        const { type, saving, isModelActual } = this.props;

        return (
            <div className={`request-editor ${saving && 'saving'} ${type}`}>
                <TextareaAutosize
                    disabled={!isModelActual}
                    minRows={1}
                    maxRows={25}
                    autoFocus={true}
                    value={text}
                    onKeyDown={this.onKeyDown}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                />
                <div className="request-editor__actions">
                    <RoundExpandableButton
                        label="Send"
                        expanded={text}
                        disabled={!text}
                        saving={saving}
                        className="test-mode_send-btn"
                        onClick={this.update} >
                        <div className={`${text && 'shown'}`}>
                            <i className="icon icon-alan-send" />
                        </div>
                    </RoundExpandableButton>
                </div>
            </div>
        );
    }
}


function mapStateToProps({ testMode, projectsInfo }, ownProps) {
    return {
        isModelActual: projectsInfo.currentProject.isModelActual,
        dialogTree: testMode.dialogTree,
        conversationId: getConversationId(projectsInfo.currentProject.conversations)
    };
}

function mapDispatchToProps() {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestEditor);

